module.exports = __webpack_public_path__ + "img/jxsy1.19efb4c0.jpg";